import { WIDGET_NUMBER_AGGREGATIONS } from "./panelTypes";
import type { WidgetColumnFormat } from "./widget/types";

export const NUMBER_PANEL_AGGREGATIONS = WIDGET_NUMBER_AGGREGATIONS;

export const NUMBER_PANEL_FORMATS: WidgetColumnFormat[] = ["text", "number", "percent", "duration"];
